import React, { useState, useEffect, useRef, useCallback } from "react";
import { Icon, Form } from "semantic-ui-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import swal from "sweetalert";
import * as yup from "yup";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import TextEditor from "../../../../components/Admin/TextEditor";

import { Container, Title, Button, Field, Input, Label } from "./styled";

import { producaov2 as api } from "../../../../services/apis";
import { isAuthAdmin } from "../../../../services/auth";
toast.configure();

const CriarEmail = () => {
  const text = useRef("");
  const [email, setEmail] = useState({
    titulo: "",
    assunto: "",
    remetente: "",
    remetenteValue: "",
  });

  useEffect(() => {
    loadAuth();
  }, []);
  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const handleSubmit = async () => {
    const EmailValidation = yup.object().shape({
      titulo: yup
        .string("Necessário que informe o titulo do email")
        .required("Necessário que informe o titulo do email"),
      assunto: yup
        .string("Necessário que informe o assunto do email")
        .required("Necessário que informe o assunto do email"),
      remetente: yup
        .string("Necessário que informe remetente do email")
        .required("Necessário que informe o remetente do email"),
    });
    try {
      await EmailValidation.validate(email, { abortEarly: true });
      const payload = {
        titulo: email.titulo,
        assunto: email.assunto,
        remetente: email.remetente + ":" + email.remetenteValue,
        conteudo: text.current,
      };
      await api
        .post("admin/email", payload)
        .then(async (res) => {
          let array = {
            local: "email",
            texto: `criou o email de id=${res.data.email.id}`,
          };
          await api.post("system_logs", { acao: JSON.stringify(array) });
          swal("Sucesso!", "Criação foi um sucesso", "success");
        })
        .catch((err) => {
          console.error(err);
          swal(
            "Erro ao criar",
            "Por favor, insira preencha todos os campos necessários",
            "error"
          );
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  return (
    <>
      <AdminMenu />

      <Container>
        <Title>Criar Modelo de E-mail</Title>
        <Form>
          <Field>
            <Label>Titulo</Label>
            <Input
              type="text"
              placeholder="Titulo"
              name="titulo"
              onChange={(e) => setEmail({ ...email, titulo: e.target.value })}
            />
          </Field>

          <Field>
            <Label>Assunto</Label>
            <Input
              type="text"
              placeholder="Assunto"
              name="assunto"
              onChange={(e) => {
                setEmail({ ...email, assunto: e.target.value });
              }}
            />
          </Field>

          <Form.Group widths="equal">
            <Field style={{ padding: 2 }}>
              <Label>Nome do Remetente</Label>
              <Input
                type="text"
                placeholder="Nome do Remetente"
                name="remetente"
                onChange={(e) =>
                  setEmail({ ...email, remetente: e.target.value })
                }
              />
            </Field>

            <Field style={{ padding: 2 }}>
              <Label>Responder para ou E-mail do Remetente</Label>
              <Input
                type="text"
                placeholder="remetente@voitto.com.br"
                name="assunto"
                onChange={(e) =>
                  setEmail({ ...email, remetenteValue: e.target.value })
                }
              />
            </Field>
          </Form.Group>

          <Field className="container media">
            <Label>Conteúdo</Label>
            <TextEditor text={text} />
          </Field>

          <Button type="submit" onClick={handleSubmit}>
            <Icon name="save" />
            Salvar
          </Button>
        </Form>
      </Container>
    </>
  );
};
export default CriarEmail;
